import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import MainLayout from '../templates/MainLayout/MainLayout';

interface IMainLayoutWrapper {
  route: any;
  titleKey: string;
}

const MainLayoutWrapper: React.FC<IMainLayoutWrapper> = ({ route, titleKey }) => {
  const { t } = useTranslation();
  const RouteComponent = route.component;

  return (
    <MainLayout>
      <Helmet title={`${t(`${titleKey}.Title`)} | Maestro`} />
      <RouteComponent />
    </MainLayout>
  );
};

export default MainLayoutWrapper;
